import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputDate} from '../../../../../../components/UI/Input'
import {SelectWrapper, InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {formatDate, formatDateType2} from '../../../../../../util/dates'
import {ClientModel, CompanyModel} from '../../../../../central/model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {CampModel, MasterModel, ModuleModel, SiteModel} from '../../../modules/models'
import {RoomModel} from '../../../room/models'
import {getRoomByIdService} from '../../../room/services/getRoomById.service'
import {getBedByIdService} from '../../services/getBedById.service'
import AditionalCamp from '../../../../../../components/UI/Form/aditionalCamp'

const FormBed: FC = () => {
  const {currentTabItem} = useHoteleria()

  const [rooms, setRooms] = useState<RoomModel[] | any>([])
  const [bedTypes, setBedTypes] = useState<MasterModel[] | any>([])
  const [statusBed, setStatusBed] = useState<MasterModel[] | any>([])
  const [subStatusBed, setSubStatusBed] = useState<MasterModel[] | any>([])
  const [bedSize, setBedSizes] = useState<MasterModel[] | any>([])
  const [camaCaliente] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [company, setCompany] = useState<CompanyModel[] | any>([])
  const [client, setClient] = useState<ClientModel[] | any>([])
  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [camps, setCamps] = useState<CampModel[] | any>([])
  const [modules, setModules] = useState<ModuleModel[] | any>([])

  const [, setValueStatus] = useState<string | any>('')

  const [showDateCC, setShowDateCC] = useState<boolean>(false)

  const {
    register,
    formState: {errors},
    setError,
    setValue,
    watch,
  } = useFormContext()

  const {getCompanies, getClients, getSites, getCamps, getMasterTable} = useCentralServices()

  const {getModules} = useModules()
  const {getRooms} = useRooms()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSites(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value)
      setError('CampamentoId', {})
      await getModulesFn(data[0].value as string)
    }
    setCamps(data)
  }

  const getModulesFn = async (campamentoId: string) => {
    const data = await getModules({CampamentoId: campamentoId})
    setModules(data)
  }

  const getRoomsFn = async (moduleId: string) => {
    const data = await getRooms({ModuloId: moduleId})
    setRooms(data)
  }

  const getBedTypesFn = async () => {
    const data = await getMasterTable('TipoCama', true)
    setBedTypes(data)
  }

  const getStatusBedFn = async () => {
    const data = await getMasterTable('EstadoCama', true)
    const orderedData = data.sort((a, b) => {
      return a.codigo.localeCompare(b.codigo)
    })
    setStatusBed(orderedData)
  }

  const getSubStatusBedFn = async (codigoPadre: string) => {
    const data = await getMasterTable('SubEstadoCama', true, {codigoPadre})
    setSubStatusBed(data)
  }

  const getBedSizesFn = async () => {
    const data = await getMasterTable('MedidaCama', true)
    setBedSizes(data)
  }

  const getBedById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getBedByIdService(idToEdit as any)
        const {
          HabitacionId,
          Codigo,
          Descripcion,
          TipoCamaId,
          EstadoCamaId,
          SubEstadoCamaId,
          MedidaCamaId,
          CamaCaliente,
          Observaciones,
          CompaniaId,
          ClienteId,
          SiteId,
          CampamentoId,
          ModuloId,
          FechaIniCC,
          FechaFinCC,
          Campoadicionaltxt1,
          Campoadicionaltxt2,
          Campoadicionaltxt3,
          Campoadicionaltxt4,
          Campoadicionaltxt5,
          Campoadicionalnum1,
          Campoadicionalnum2,
          Campoadicionalnum3,
          CampoadicionalFec1,
          CampoadicionalFec2,
        } = data
        setValue('Id', idToEdit)
        setValue('HabitacionId', HabitacionId)
        setValue('Descripcion', Descripcion)
        setValue('TipoCamaId', TipoCamaId)
        setValue('EstadoCamaId', EstadoCamaId)
        setValue('Codigo', Codigo)
        setValue('SubEstadoCamaId', SubEstadoCamaId)
        setValue('MedidaCamaId', MedidaCamaId)
        setValue('CamaCaliente', CamaCaliente)
        setValue('Observaciones', Observaciones)
        setValue('CompaniaId', CompaniaId)
        setValue('ClienteId', ClienteId)
        setValue('SiteId', SiteId)
        setValue('CampamentoId', CampamentoId)
        setValue('ModuloId', ModuloId)
        setValue('FechaIniCC', formatDate(FechaIniCC))
        setValue('FechaFinCC', formatDate(FechaFinCC))
        setValue('Campoadicionaltxt1', Campoadicionaltxt1)
        setValue('Campoadicionaltxt2', Campoadicionaltxt2)
        setValue('Campoadicionaltxt3', Campoadicionaltxt3)
        setValue('Campoadicionaltxt4', Campoadicionaltxt4)
        setValue('Campoadicionaltxt5', Campoadicionaltxt5)
        let num1 = Campoadicionalnum1 ? (Campoadicionalnum1 === 0 ? '' : Campoadicionalnum1) : ''
        let num2 = Campoadicionalnum2 ? (Campoadicionalnum2 === 0 ? '' : Campoadicionalnum2) : ''
        let num3 = Campoadicionalnum3 ? (Campoadicionalnum3 === 0 ? '' : Campoadicionalnum3) : ''
        if (CamaCaliente) {
          setShowDateCC(true)
        } else {
          setShowDateCC(false)
        }
        setValue('Campoadicionalnum1', num1)
        setValue('Campoadicionalnum2', num2)
        setValue('Campoadicionalnum3', num3)
        setValue('CampoadicionalFec1', formatDateType2(CampoadicionalFec1))
        setValue('CampoadicionalFec2', formatDateType2(CampoadicionalFec2))
        getClientsFn(CompaniaId as any)
        getSitesFn(ClienteId as any)
        getCampsFn(SiteId as any)
        getModulesFn(CampamentoId as any)
        getRoomsFn(ModuloId as any)

        setValueStatus(EstadoCamaId)
        const filtered = statusBed.filter((item: any) => item.value === EstadoCamaId)[0]?.codigo

        getSubStatusBedFn(filtered)
      }
    } catch (error) {}
    // setLoading(true)

    // setLoading(false)
  }

  useEffect(() => {
    if (currentTabItem.idToEdit && statusBed.length > 0) {
      getBedById()
    }
  }, [currentTabItem.idToEdit, statusBed])

  useEffect(() => {
    getBedTypesFn()
    getStatusBedFn()
    getCompaniesFn()
    getBedSizesFn()
    setValue('CamaCaliente', false)
  }, [])

  useEffect(() => {
    if (statusBed.length > 0) {
      const defaultStatus = statusBed.find((item: any) => item.label === 'DISPONIBLE')?.value
      const filtered =
        statusBed.filter((item: any) => item.value === defaultStatus)[0]?.codigo || ''
      getSubStatusBedFn(filtered)
      if (!currentTabItem.idToEdit) {
        setValue('EstadoCamaId', defaultStatus)
      }
    }
  }, [statusBed])

  useEffect(() => {
    if (subStatusBed.length > 0) {
      const defaultStatus = subStatusBed.find((item: any) => item.label === 'HABILITADA')?.value
      if (!currentTabItem.idToEdit) {
        setValue('SubEstadoCamaId', defaultStatus)
        setError('SubEstadoCamaId', {})
      }
    }
  }, [subStatusBed])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})

    getClientsFn(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)

    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSitesFn(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)

    setValue('CampamentoId', '')

    getCampsFn(value)

    setError('SiteId', {})
  }

  const handleCampChange = (val: any) => {
    let value = val ? val.value : ''
    // setValueCamp(value)
    setValue('CampamentoId', value)
    getModulesFn(value)
    setError('CampamentoId', {})
  }

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ModuloId', value)
    getRoomsFn(value)
    setError('ModuloId', {})
  }

  const handleStatusChange = (val: any) => {
    let value = val ? val.value : ''
    setValueStatus(value)
    setValue('EstadoCamaId', value)
    const filtered = statusBed.filter((item: any) => item.value === value)[0]?.codigo
    getSubStatusBedFn(filtered)
    setError('EstadoCamaId', {})
    setValue('SubEstadoCamaId', '')
  }

  const handleCamaCalienteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CamaCaliente', value)
    setError('CamaCaliente', {})
    if (value) {
      setShowDateCC(true)
      setValue('FechaIniCC', moment().format('YYYY-MM-DD'))
      setValue('FechaFinCC', moment().add(4, 'years').format('YYYY-MM-DD'))
    } else {
      setShowDateCC(false)
      setValue('FechaIniCC', '')
      setValue('FechaFinCC', '')
    }
  }

  const handleRoomChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('HabitacionId', value)
    setError('HabitacionId', {})
    getRoomById(value)
  }

  const getRoomById = async (roomId: string) => {
    try {
      const {
        data: {data},
      } = await getRoomByIdService(roomId)
      const {TipoHabitacionId} = data
      const assignedTypeBed = {
        'Vat+s8wuM3o=': '9oQq8MRcnbI=',
        'SZvafLlTvbA=': 'PXV1xwjvg9Y=',
        '4plRqC3ZEIM=': 'PlKj+bDAupo=',
        'E5y+qCfUkf0=': 'PB4Wu3YL+hU=',
      } as any
      setValue('TipoCamaId', assignedTypeBed[TipoHabitacionId as any])
      setError('TipoCamaId', {})
    } catch (error) {}
  }

  const handleGetFirstDate = (e: any) => {
    setValue('FechaIniCC', e.target.value)
  }
  const handleGetSecondDate = (e: any) => {
    setValue('FechaFinCC', e.target.value)
  }

  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <div className='sdx_form card p-4'>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='CompaniaId'
            data={company}
            onChangeValue={handleCompanyChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={client}
            onChangeValue={handleClientChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={sites}
            onChangeValue={handleSiteChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Campamento'
            name='CampamentoId'
            data={camps}
            onChangeValue={handleCampChange}
            required
          />
        </div>
      </div>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Nomenclatura de Módulo'
            name='ModuloId'
            data={modules}
            onChangeValue={handleModuleChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Nomenclatura de Habitación'
            name='HabitacionId'
            data={rooms}
            onChangeValue={handleRoomChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Nomenclatura de Cama'
            name='Codigo'
            textPlaceholder='Escribe la Nomenclatura de Cama'
            type='ticketNumber'
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Notas de la Cama'
            name='Descripcion'
            textPlaceholder='Escribe notas de la cama'
          />
        </div>
      </div>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper labelText='Tipo de Cama' name='TipoCamaId' data={bedTypes} required />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Estado de Cama'
            name='EstadoCamaId'
            data={statusBed}
            onChangeValue={handleStatusChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Sub Estado de Cama'
            name='SubEstadoCamaId'
            data={subStatusBed}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper labelText='Tipo de Medida de Cama' name='MedidaCamaId' data={bedSize} />
        </div>
      </div>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cama Caliente'
            name='CamaCaliente'
            data={camaCaliente}
            onChangeValue={handleCamaCalienteChange}
            required
          />
        </div>
        {showDateCC ? (
          <>
            <div className='col-sm-12 col-lg-3'>
              <label>Fecha Inicio :</label>
              <InputDate
                name='FechaIniCC'
                register={register}
                errors={errors}
                defaultValue={moment().format('YYYY-MM-DD')}
                minValue={isDisabled ? undefined : moment().subtract(1, 'day').format('YYYY-MM-DD')}
                onChange={(e: any) => handleGetFirstDate(e)}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Fecha Fin:</label>
              <InputDate
                name='FechaFinCC'
                register={register}
                errors={errors}
                minValue={isDisabled ? undefined : moment().subtract(1, 'day').format('YYYY-MM-DD')}
                onChange={handleGetSecondDate}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      <hr className='divider' />
      <AditionalCamp module='hoteleria' />
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}

export {FormBed}
